import { Injectable } from '@angular/core';

import { RestService } from '../core/rest.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class StaffReportService {
  constructor(private readonly rest: RestService) {}

  getLicensesWithManagementBillingTypeWithoutRenewalDate(): Promise<any> {
    return this.rest.get(
      `${environment.apiUrl}/api/staff/report/licenses-with-management-billing-type-without-renewal-date`
    );
  }
}
